import React from "react";
import { useSystemBroadcast } from "./useSystemBroadcast";
import "./SystemBroadcastBanner.css";

// Recognised severities. Anything unknown falls back to "info".
const LEVELS = { info: "info", warning: "warning", critical: "critical" };

/**
 * SystemBroadcastBanner — dismissible, level-styled banners for active system
 * broadcasts (PLEX-4102). Polls the public endpoint via useSystemBroadcast;
 * renders nothing when there is nothing active/undismissed.
 */
export const SystemBroadcastBanner = ({ authData = null }) => {
  const { visible, dismiss } = useSystemBroadcast(authData);

  if (!visible || visible.length === 0) return null;

  return (
    <div
      className="broadcasts"
      data-testid="v2-broadcasts"
      role="region"
      aria-label="System announcements"
    >
      {visible.map((b) => {
        const level = LEVELS[b.level] || "info";
        return (
          <div
            key={b.id}
            className={`broadcast broadcast--${level}`}
            data-testid="v2-broadcast"
            data-level={level}
            role={level === "critical" ? "alert" : "status"}
          >
            <span className="broadcast__message">{b.message}</span>
            <button
              type="button"
              className="broadcast__dismiss"
              aria-label="Dismiss announcement"
              data-testid="v2-broadcast-dismiss"
              onClick={() => dismiss(b.id)}
            >
              ✕
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default SystemBroadcastBanner;
